import React from 'react';
import { forBrands, css, useTheme } from '@core-ui/react-stitch';

const getFontSize = (breakPoints) => {
  return breakPoints.isSmall || breakPoints.isMedium
    ? '0.8125rem!important'
    : '0.9375rem!important';
};

const getSpaceBwlines = (isLarge) => {
  return isLarge ? '0.25rem!important' : '0.1875rem!important';
};

const getBRLineHeight = (breakPoints) => {
  return breakPoints.isSmall || breakPoints.isMedium ? '0.813rem' : '1.2';
};

const getBrValuesArray = (theme, breakpoints, isBRRedesignEnabled) => {
  const brValues = {
    brRedesign: {
      color: theme.color.wh,
      letterSpacing: 'unset',
      fontSize: breakpoints.isXLarge
        ? '1.0625rem!important'
        : getFontSize(breakpoints),
      lineHeightDiv: 'normal',
      lineHeightSpan: getBRLineHeight(breakpoints),
    },
    brDefault: {
      color: theme.color.b1,
      letterSpacing: '0.5',
      fontSize: '0.8rem',
      lineHeightDiv: '1.4',
      lineHeightSpan: '1.2',
    },
  };

  return isBRRedesignEnabled ? brValues.brRedesign : brValues.brDefault;
};

const commonBRStyles = (theme, breakpoints, isBRRedesignEnabled) => {
  const brValues = getBrValuesArray(theme, breakpoints, isBRRedesignEnabled);
  const style = css`
    & span {
      color: ${brValues.color};
      font-family: ${theme.brandFont.fontFamily};
      font-size: ${brValues.fontSize};
      letter-spacing: ${brValues.letterSpacing};
      line-height: ${brValues.lineHeightSpan};
    }
    padding-top: ${breakpoints.isXLarge
      ? '0.5rem!important'
      : getSpaceBwlines(breakpoints.isLarge)};
    & div:first-of-type {
      line-height: ${brValues.lineHeightDiv};
    }
  `;
  return style;
};

const brRedesignPriceStyles = (theme, isBRRedesignEnabled) => {
  const fontStyles = `
    color: ${theme.color.wh};
    font-weight: 350;
    font-family: ${theme.brandFont.fontFamily};
  `;

  return isBRRedesignEnabled
    ? css`
        div.product-price__markdown {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline;
          margin-right: 0.3rem;
          text-decoration: line-through;
          ${fontStyles}
        }
        ,
        span.product-price__no-strike {
          ${fontStyles}
        }
        ,
        span.product-price__highlight--br {
          ${fontStyles}
          padding-bottom: none;
        }
        ,
        .product-card-price {
          ${fontStyles}
        }
      `
    : '';
};

const colorOverrides = (theme, breakpoints, isBRRedesignEnabled) =>
  forBrands(theme, {
    br: css`
      div.product-price__highlight--br {
        color: ${theme.color.b1};
      }
      span.product-price__highlight--br {
        color: ${theme.color.b1};
      }
      ${commonBRStyles(theme, breakpoints, isBRRedesignEnabled)}
      ${brRedesignPriceStyles(theme, isBRRedesignEnabled)}
    `,
    brfs: css`
      div.product-price__option--br {
        color: ${theme.color.b1};
      }
      ${commonBRStyles(theme, breakpoints, isBRRedesignEnabled)}
      ${brRedesignPriceStyles(theme, isBRRedesignEnabled)}
    `,
  });

export const ProductPriceWrapper = ({
  breakPoints,
  children,
  isBRRedesignEnabled,
}) => {
  const theme = useTheme();
  return (
    <div
      className="product-card-price"
      css={colorOverrides(theme, breakPoints, isBRRedesignEnabled)}
    >
      {children}
    </div>
  );
};
